import classNames from "classnames";
import * as React from "react";

export const OffshoreBondFolderIcon = (props: any) => {
    const cssWrapper = classNames(props.isCompleted && "is-completed", "product-icon");
    return (
        <div className={cssWrapper}>
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="58" viewBox="0 0 64 58">
                <g fill="none" fillRule="evenodd">
                    <path
                        fill="var(--cta1)"
                        d="M52.9909091,58 L12.0745455,58 C9.33272727,58 7.06545455,55.7327273 7.06545455,52.9909091 L7.06545455,17.7163636 C7.06545455,14.9745455 9.33272727,12.7072727 12.0745455,12.7072727 L52.9909091,12.7072727 C55.7327273,12.7072727 58,14.9745455 58,17.7163636 L58,52.9909091 C58,55.7327273 55.7327273,58 52.9909091,58 Z M12.0745455,14.2890909 C10.1763636,14.2890909 8.64727273,15.8181818 8.64727273,17.7163636 L8.64727273,52.9909091 C8.64727273,54.8890909 10.1763636,56.4181818 12.0745455,56.4181818 L52.9909091,56.4181818 C54.8890909,56.4181818 56.4181818,54.8890909 56.4181818,52.9909091 L56.4181818,17.7163636 C56.4181818,15.8181818 54.8890909,14.2890909 52.9909091,14.2890909 L12.0745455,14.2890909 Z"
                    />
                    <path
                        fill="var(--cta1)"
                        d="M5.00909091,57.9472727 C2.26727273,57.9472727 0,55.68 0,52.9381818 L0,5.00909091 C0,2.26727273 2.26727273,0 5.00909091,0 L20.5636364,0 C23.3054545,0 25.5727273,2.26727273 25.5727273,5.00909091 L25.5727273,7.06545455 L52.9909091,7.06545455 C53.4127273,7.06545455 53.7818182,7.43454545 53.7818182,7.85636364 C53.7818182,8.27818182 53.4127273,8.64727273 52.9909091,8.64727273 L24.7818182,8.64727273 C24.36,8.64727273 23.9909091,8.27818182 23.9909091,7.85636364 L23.9909091,5.00909091 C23.9909091,3.11090909 22.4618182,1.58181818 20.5636364,1.58181818 L5.00909091,1.58181818 C3.11090909,1.58181818 1.58181818,3.11090909 1.58181818,5.00909091 L1.58181818,52.9381818 C1.58181818,54.8363636 3.11090909,56.3654545 5.00909091,56.3654545 C5.43090909,56.3654545 5.8,56.7345455 5.8,57.1563636 C5.8,57.5781818 5.43090909,57.9472727 5.00909091,57.9472727 Z"
                    />
                    <text
                        fill="var(--cta1)"
                        fontFamily="StandardLife-Light_Beta5, Standard Life"
                        fontSize="18"
                        fontWeight="300"
                    >
                        <tspan x="20" y="42">
                            IPB
                        </tspan>
                    </text>
                </g>
            </svg>
        </div>
    );
};
